// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import React from "react";
import { ButtonDropdown, Link } from "@cloudscape-design/components";
import { Trans, useTranslation } from "react-i18next";
import "./style.css";
import useI18nLanguage from "./useI18nLanguage";
import { Language, LANGUAGE_DISPLAY_NAMES } from "../../../i18n";
import { getEnabledLanguages } from "../../../utils/customBrandingUtils";
import { CustomColorThemeSpan } from "../../general/CustomColorTheme/CustomColorTheme";
import { getCustomBrandingConfig } from "../../../configurations";
import { AWS_CONTACT_US_LINK } from "../../../constants/Common";
import { isEmptyString, isNotEmptyString } from "../../../utils/commonUtils";
import { TestIds } from "../../../constants/TestIds";

const Header = () => {
    const { language, changeLanguage } = useI18nLanguage();
    const { t } = useTranslation();
    const enabledLanguages = getEnabledLanguages();

    const handleLanguageChange = (event) => {
        const selectedLanguage = event.detail.id;
        changeLanguage(selectedLanguage);
    };

    let languageList = Object.entries(LANGUAGE_DISPLAY_NAMES).map(
        ([lngCode, lngDisplayName]) => ({
            id: lngCode as Language,
            text: lngDisplayName,
        })
    );
    if (enabledLanguages && enabledLanguages.size > 0) {
        languageList = languageList.filter((lang) =>
            enabledLanguages.has(lang.id)
        );
    }

    const customBrandingConfig = getCustomBrandingConfig();
    const contactLink = isEmptyString(customBrandingConfig?.userSettingId)
        ? AWS_CONTACT_US_LINK
        : t("branding.contactLink");

    return (
        <div className="euc-header-container-style">
            {isNotEmptyString(contactLink, true) && (
                <Link
                    href={contactLink}
                    target="_blank"
                    rel="noreferrer"
                    variant="info"
                    data-testid={TestIds.CONTACT_US_BUTTON}
                >
                    <span className="euc-header-span-style">
                        <CustomColorThemeSpan>
                            <Trans i18nKey="euc.signIn.header.contactUs.label" />
                        </CustomColorThemeSpan>
                    </span>
                </Link>
            )}

            <ButtonDropdown
                items={languageList}
                onItemClick={handleLanguageChange}
            >
                {LANGUAGE_DISPLAY_NAMES[language]}
            </ButtonDropdown>
        </div>
    );
};

export default Header;
